export enum LoadingMethod {
  loadIsLoaded = 'loadIsLoaded',
  loadIsInTow = 'loadIsInTow',
  loadIsSelfPropelled = 'loadIsSelfPropelled',
}

export const LoadingMethodValues = Object.values(LoadingMethod);
